import moment from 'moment'
import axios from 'axios'

const namespaced = true
// state
const state = {
    bids: [],
    bid_messages: [],
    last_checked: null
}

// getters
const getters = {
    bids: state => state.bids,
    unread_bids: state => state.bids.filter(msg => msg.read_at === null),
    bids_count: state => state.bids.length,
    unread_bids_count: state => state.bids.filter(msg => msg.read_at === null).length,

    bid_messages: state => state.bid_messages,
    unread_bid_messages: state => state.bid_messages.filter(msg => msg.read_at === null),
    bid_messages_count: state => state.bid_messages.length,
    unread_bid_messages_count: state => state.bid_messages.filter(msg => msg.read_at === null).length,
}

// mutations
const mutations = {
    setNotifications(state, notifications) {
        state.bids = notifications.bids
        state.bid_messages = notifications.bid_messages
    },
    updateLastChecked(){
        state.last_checked = moment()
    }
}

// actions
const actions = {
    maybeGetNotifications ({ commit, dispatch }, mins = 5) {
        let needsCheck = false
        if (!state.last_checked) {
            needsCheck = true
        } else {
            let time = moment().subtract(mins, 'minutes');
            if (time.isAfter(state.last_checked)) {
                needsCheck = true
            }

        }
        if (needsCheck) {
            dispatch('getNotifications')
        }
    },
    async getNotifications({commit}) {
        try {
            let res = await axios.get('/notifications');
            if (res && res.data) {
                commit('setNotifications', res.data)
            }
            commit('updateLastChecked')
        } catch (e) {
            console.warn('err in vuex notifications/getNotifications', e)
        }
    },
    async markRead({commit}, notification_ids) {
        try {
            let res = await axios.put('/notifications', {read_ids: notification_ids});
            if (res && res.data && res.data) {
                commit('setNotifications', res.data)
            }
        } catch (e) {
            console.warn('err in vuex notifications/markRead', e)
        }
    }
}

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/notifications.js